import React, {useState} from "react";
import {Box, Tab, Tabs} from "@mui/material";
import {Link} from "react-router-dom";
import User from "../backend/User";

export default function NavbarComponent({initValue}) {

    const [value, setValue] = useState(initValue);

    function handleChange(event, newValue) {
        setValue(newValue);
    }

        return (
            <>
                <Box sx={{width: '100%', margin: '10px', borderBottom: '1px solid lightgrey'}}>
                    {User.getRole() === 'Verwalter' ?
                        <Tabs value={value} onChange={handleChange} variant={"fullWidth"}>
                            <Tab label={"Neue Anmeldungen"} value={"/application"} component={Link} to={"/application"}/>
                            <Tab label={"Mitarbeiter"} value={"/employees"} component={Link} to={"/employees"}/>
                            <Tab label={"Kurse"} value={"/courses"} component={Link} to={"/courses"}/>
                            <Tab label={"Verwaltung"} value={"/management/courses"} component={Link} to={"/management/courses"}/>
                        </Tabs>
                        :
                        <Tabs value={value} onChange={handleChange} variant={"fullWidth"}>
                            <Tab label={"Start"} value={"/start"} component={Link} to={"/start"}/>
                            <Tab label={"Übersicht"} value={"/overview"} component={Link} to={"/overview"}/>
                            <Tab label={"Kursplanung"} value={"/matrix"} component={Link} to={"/matrix"}/>
                            <Tab label={"Mitarbeiter"} value={"/employees"} component={Link} to={"/employees"}/>
                            <Tab label={"Kurse"} value={"/courses"} component={Link} to={"/courses"}/>
                        </Tabs>
                    }
                </Box>
            </>
        );
}